import { render, staticRenderFns } from "./wiki_content.vue?vue&type=template&id=0271a27a&vue3"
import script from "./wiki_content.vue?vue&type=script&lang=js&vue3"
export * from "./wiki_content.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports